import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material';
import dayjs from 'dayjs';
import { useThemeContext } from './contexts/BaseThemeContextProvider';

const StyledDatePicker = styled(DatePicker)(({ theme, customStyles }) => ({
  '& .MuiInputBase-root': {
    ...customStyles,
  },
}));

const CustomDatePicker = ({
  value,
  onChange,
  label,
  customStyles = {},
  TextFieldProps = {},
  DatePickerProps = {},
  error,
  helperText,
}) => {
  const { theme } = useThemeContext();

  const sxDateButtonStyles = {
    '&:hover': {
      color: theme.custom.components.customDatePicker.slotProps.optionButtonStyles.hover.color,
      backgroundColor: theme.custom.components.customDatePicker.slotProps.optionButtonStyles.hover.backgroundColor,
    },
    '&.Mui-selected': {
      backgroundColor: theme.custom.components.customDatePicker.slotProps.optionButtonStyles.selected.backgroundColor,
      color: theme.custom.components.customDatePicker.slotProps.optionButtonStyles.selected.color,
      '&:hover': {
        color: theme.custom.components.customDatePicker.slotProps.optionButtonStyles.selected.hover.color,
        backgroundColor:
          theme.custom.components.customDatePicker.slotProps.optionButtonStyles.selected.hover.backgroundColor +
          ' !important',
      },
      '&:focus': {
        backgroundColor:
          theme.custom.components.customDatePicker.slotProps.optionButtonStyles.selected.focus.backgroundColor,
      },
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledDatePicker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          if (!newValue || !newValue.isValid()) {
            // Handle both null and invalid cases by passing null to Formik
            onChange(null);
            return;
          }
          // Handle the valid date case
          onChange(newValue.format('YYYY-MM-DD'));
        }}
        slotProps={{
          textField: {
            ...TextFieldProps,
            fullWidth: true,
            error: error,
            helperText: helperText,
            inputProps: {
              ...TextFieldProps.inputProps,
              placeholder: 'DD/MM/YYYY',
            },
          },
          yearButton: { sx: sxDateButtonStyles },
          monthButton: { sx: sxDateButtonStyles },
          day: { sx: sxDateButtonStyles },
          // For desktop devices
          popper: {
            sx: {
              '& .MuiPaper-root': {
                marginTop: '12px',
                border: '2px solid',
                borderColor: theme.custom.components.customDatePicker.popperContainer.borderColor,
                backgroundColor:
                  theme.custom.components.customDatePicker.popperContainer.backgroundColor + ' !important',
                backgroundImage: 'none',
                borderRadius: '8px',
                boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
                // The trick to fix the border right bottom without border issue
                overflow: 'hidden',
                // hidding scrollbar
                scrollbarWidth: 'none', // Firefox
                '&::-webkit-scrollbar': {
                  display: 'none', // Chrome, Safari, Edge
                },
                msOverflowStyle: 'none', // IE
              },
            },
          },
          // For mobile devices
          dialog: {
            sx: {
              '& .MuiDialogContent-root': {
                padding: 0,
              },
              '& .MuiPaper-root': {
                borderRadius: '8px',
                border: '2px solid',
                borderColor: theme.custom.components.customDatePicker.popperContainer.borderColor,
                backgroundColor: theme.custom.components.customDatePicker.popperContainer.backgroundColor,
                // The trick to fix the border right bottom without border issue
                overflow: 'hidden',
              },
            },
          },
        }}
        disableFuture
        openTo="year"
        views={['year', 'month', 'day']}
        customStyles={customStyles}
        {...DatePickerProps}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
